import { render, staticRenderFns } from "./DefaultParamForm.vue?vue&type=template&id=4212c214"
import script from "./DefaultParamForm.vue?vue&type=script&lang=js"
export * from "./DefaultParamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports